module.exports = "data:image/gif;base64,R0lGODlhDAAMAJEAAAAAAJmZmf///wAAACH5BAAAAAAALAAAAAAMAAwAAAIYhB+ph5oCo4TMuDdzBTdkXXXftIljVF4FADs="